export const amountFields = `
    fragment amountFields on MoneyV2 {
        amount
        currencyCode
    }
`;
